import { render, staticRenderFns } from "./xuetangyi.vue?vue&type=template&id=5bf198ae&scoped=true&"
import script from "./xuetangyi.vue?vue&type=script&lang=js&"
export * from "./xuetangyi.vue?vue&type=script&lang=js&"
import style0 from "./xuetangyi.vue?vue&type=style&index=0&id=5bf198ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf198ae",
  null
  
)

export default component.exports